require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-should-i-pay-discount-points.json") })
        }
      }, "path---calculators-should-i-pay-discount-points");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-should-i-pay-discount-points!./.cache/json/calculators-should-i-pay-discount-points.json
// module id = 2022
// module chunks = 231608221292675